<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Remove from Location List</p>
        <span
          class="icon is-right"
          @click="closeModal">
          <font-awesome-icon :icon="['fal', 'times']" />
        </span>
      </header>
      <section class="modal-card-body">
        <div class="modal-body">
          Are you sure you want to remove this location form the location list?
        </div>
        <div class="update-box">
          <a @click="closeModal">Cancel</a>
          <button
            class="button is-primary"
            @click="deleteLocation">
              Remove Location
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTimes,
} from '@fortawesome/pro-light-svg-icons';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faTimes,
);

export default {
  mixins: [NotificationManager],
  props: ['groupId', 'locationId', 'childLevel', 'parentId'],
  methods: {
    async deleteLocation() {
      try {
        await axios.delete(`location-groups/${this.groupId}/location-group-mappings/`+            
            `${this.locationId}?childLevel=${this.childLevel}&parentId=${this.parentId}`);
        this.showNotification('success', ['Location successfully removed.']);
      } catch (error) {
        const { status } = error.response;
        let apiMsg = '';

        if (status === 500) {
          apiMsg = 'Network Error';
        } else if (status === 400) {
          apiMsg = 'Something went wrong.';
        } else {
          apiMsg = `${error.response.data.message}`;
        }
        this.showNotification('danger', [apiMsg]);
      }
      this.$emit('updateList');
    },
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
</script>

<style lang="sass" scoped>
  .modal-card-head
    background-color: #F5F5F5
    text-align: left
  .modal-card-title
    margin-bottom: 0 !important
  .modal-card-body
    border-bottom-right-radius: .4rem
    border-bottom-left-radius: .4rem
  .modal-body
    margin-bottom: 1rem
    display: flex
    justify-content: flex-start
  .update-box
    display: flex
    align-items: center
    justify-content: flex-end
    button
      margin-left: 1rem
</style>
